import { useContext } from "react";
import { SolutionKeyContext } from "../SolutionKeyContext";

export const useSolutionKey = () => useContext(SolutionKeyContext);
